/**
 * 全角数字を半角数字に変換し、半角数字以外は削除します。
 *
 * @param {string} str 文字列
 * @param {boolean} allow 非数字の文字を許可するかどうか
 * @returns {string}
 */
export function toInt(str, allow = false) {
    const fullToHalf = {
        '０': '0',
        '１': '1',
        '２': '2',
        '３': '3',
        '４': '4',
        '５': '5',
        '６': '6',
        '７': '7',
        '８': '8',
        '９': '9'
    };

    str = [...str].map((char) => fullToHalf[char] || char).join('');

    if (!allow) {
        str = str.replace(/\D/g, '');
    }

    return str;
}
